<template>
  <div v-if="zbozi.active" class="mb-1 shaim-zbozi-consent">
    <div class="form-check">
      <input id="shaim_zbozi_consent_checkbox" type="checkbox" class="form-check-input" :checked="zbozi.checked" @change="updateValue">
      <label class="form-check-label" for="shaim_zbozi_consent_checkbox">
        {{ zbozi.text }}
      </label>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      zbozi: state => state.shaimZboziCz,
    }),
  },
  methods: {
    updateValue (e) {
      this.$store.commit('shaimZboziCz/SET', e.target.checked);
    }
  },
};
</script>
